export default __webpack_public_path__ + "static/media/GraftCafe.fac4fccd.jpg";